<template>
    <div>
        <v-dialog v-model="showAITextOption" @click:outside="closeDialog" persistent max-width="700">
            <v-card>
                <Loading />
                <v-toolbar dark>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{ $t('getTextFromAI') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container class="text-center">
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="12">
                                <v-textarea v-model="textInstruction" :label="$t('instructAI')"
                                    :rules="[rules.required, rules.counter]" rows="1" maxlength="250"
                                    clearable></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-btn @click="generateText" class="text-capitalize" outlined>{{ $t('generateText')
                                }}</v-btn>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Loading from '../common/Loading.vue'
export default {
    name: 'AiQuestionParameter',
    components: {
        Loading
    },
    data() {
        return {
            textInstruction: '',
            rules: {
                required: value => !!value || this.$t('required'),
                counter: value => (value && value.length <= 250) || this.$t('max250characters'),
            },
        }
    },
    methods: {
        reset() {
            this.textInstruction = ''
        },
        closeDialog() {
            this.$store.dispatch('quiz/switchShowAiTextParameter', false)
        },
        generateText() {
            if (this.$store.getters['dashboard/selectedAi'] == 'Gemini AI') {
                this.generateGeminiAiText()
            } else {
                this.generateOpenAiText()
            }
        },
        generateOpenAiText() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('dashboard/applyLoading')
                const objInstructions = {
                    textInstruction: this.textInstruction,
                }
                this.$store.dispatch('quiz/generateOpenAiText', objInstructions)
                    .then((response) => {
                        this.$store.dispatch('dashboard/cancelLoading')
                        if (response.status == 200) {
                            this.reset()
                            this.$store.dispatch('quiz/setAiGeneratedText', response.data.output)
                        } else if (response.status == 202) {
                            this.$root.$emit('message_from_parent_long', this.$t(response.data.responseMsg))
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        },
        generateGeminiAiText() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('dashboard/applyLoading')
                const objInstructions = {
                    textInstruction: this.textInstruction,
                }
                this.$store.dispatch('quiz/generateGeminiAiText', objInstructions)
                    .then((response) => {
                        this.$store.dispatch('dashboard/cancelLoading')
                        if (response.status == 200) {
                            this.reset()
                            this.$store.dispatch('quiz/setAiGeneratedText', response.data.output)
                        } else if (response.status == 202) {
                            this.$root.$emit('message_from_parent_long', this.$t(response.data.responseMsg))
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        }
    },
    computed: {
        showAITextOption: function () {
            return this.$store.getters['quiz/showAiTextParameter']
        },
    },
}
</script>